import { callServiceAPI } from './ApiUtils';
var platformCoreWebServicesPrefix = "https://api.platform.appmachine.in";

export function startHealthcheckAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/starthealthcheck", "POST", payload, successCallBack, failuerCallback);
}export function logMsgAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/logmsg", "POST", payload, successCallBack, failuerCallback);
}export function logReqAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/logreq", "POST", payload, successCallBack, failuerCallback);
}export function initWorkflowAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/initworkflow", "POST", payload, successCallBack, failuerCallback);
}export function completeTaskAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/completetask", "PUT", payload, successCallBack, failuerCallback);
}export function getMyTaskListAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/getmytasklist", "POST", payload, successCallBack, failuerCallback);
}export function markTaskInstanceAsWIPAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/marktaskInstanceaswip", "PUT", payload, successCallBack, failuerCallback);
}export function markTaskAsWIPAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/marktaskaswip", "PUT", payload, successCallBack, failuerCallback);
}export function rejectTaskAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/rejecttask", "PUT", payload, successCallBack, failuerCallback);
}export function addStageAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/addstage", "POST", payload, successCallBack, failuerCallback);
}export function connectStagesAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/connectStages", "PUT", payload, successCallBack, failuerCallback);
}export function disconnectStagesAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/disconnectstages", "DELETE", payload, successCallBack, failuerCallback);
}export function updateStageAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/updateStage", "PUT", payload, successCallBack, failuerCallback);
}export function addTaskAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/addtask", "POST", payload, successCallBack, failuerCallback);
}export function updateTaskAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/updatetask", "PUT", payload, successCallBack, failuerCallback);
}export function connect1ToNAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/connect1ToN", "POST", payload, successCallBack, failuerCallback);
}export function disconnect1toNAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/disconnect1ton", "DELETE", payload, successCallBack, failuerCallback);
}export function deleteStageAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/deletestage", "DELETE", payload, successCallBack, failuerCallback);
}export function saveStagesPositionAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/savestagesposition", "PUT", payload, successCallBack, failuerCallback);
}export function addCommentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/addcomment", "POST", payload, successCallBack, failuerCallback);
}export function editCommentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/editcomment", "PUT", payload, successCallBack, failuerCallback);
}export function updateCommentStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/updatecommentstatus", "PUT", payload, successCallBack, failuerCallback);
}export function deleteCommentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/deletecomment", "DELETE", payload, successCallBack, failuerCallback);
}export function initTaskAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/inittask", "POST", payload, successCallBack, failuerCallback);
}export function refreshWkfAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/refreshwkf", "PUT", payload, successCallBack, failuerCallback);
}export function stageSummaryAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/stagesummary", "POST", payload, successCallBack, failuerCallback);
}export function markTaskInstanceWipAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/marktaskinstancewip", "PUT", payload, successCallBack, failuerCallback);
}export function RunReportAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/runreport", "POST", payload, successCallBack, failuerCallback);
}export function SendWABAmessageAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/sendwabamessage", "POST", payload, successCallBack, failuerCallback);
}export function ReceiveWABAmsgStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/receivewabmsgstatus", "POST", payload, successCallBack, failuerCallback);
}export function SendWABAotpAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/sendwabaotp", "POST", payload, successCallBack, failuerCallback);
}export function SendWABAmsgAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/sendwabamsg", "POST", payload, successCallBack, failuerCallback);
}export function getOrphandTaskInsAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/getorphandtaskins", "POST", payload, successCallBack, failuerCallback);
}export function refreshTaskInstsAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/refreshtaskinsts", "POST", payload, successCallBack, failuerCallback);
}export function registerErrorAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(platformCoreWebServicesPrefix+"/registererror", "POST", payload, successCallBack, failuerCallback);
}export function markTaskTODOAPI(payload, successCallBack, failuerCallback){
    callServiceAPI(platformCoreWebServicesPrefix+"/marktasktodo", "POST", payload, successCallBack, failuerCallback);
}
